import { createActions, createReducer } from 'reduxsauce';
import { fromJS, Record } from 'immutable';

export const { Types, Creators } = createActions({
  getDataRequest: [],
  getDataSuccess: ['data', 'territories'],
  getDataError: ['e'],
  getDetailsRequest: ['id'],
  getDetailsSuccess: ['data'],
  getDetailsError: ['e'],
  patchTouchpointRequest: ['id', 'confirmed', 'territory'],
  patchTouchpointSuccess: ['id'],
  patchTouchpointError: ['e']
}, {
  prefix: 'TOUCHPOINT_VALIDATION_'
});

const state = new Record({
  data: null,
  details: null,
  territories: null,
  count: null,
  isPatching: false,
  error: null
});

const INITIAL_STATE = new state({
  data: null,
  details: null,
  territories: null,
  count: 0
});

const getDataRequest = (state = INITIAL_STATE) => state;

const getDataSuccess = (state = INITIAL_STATE, { data, territories }) =>
  state.set('data', fromJS(data))
    .set('territories', fromJS(territories))
    .set('count', 0)
    .set('details', null)
    .set('error', null);

const getDataError = (state = INITIAL_STATE) => state;

const getDetailsRequest = (state = INITIAL_STATE) => state.set('error', null);

const getDetailsSuccess = (state = INITIAL_STATE, { data }) => state.set('details', fromJS(data)).set('error', null);

const getDetailsError = (state = INITIAL_STATE, { e }) =>
  state.set('error', e ? 'Unable to load this touchpoint. Please try again.' : null);

const patchTouchpointRequest = (state = INITIAL_STATE) => state.set('isPatching', true).set('error', null);

const patchTouchpointSuccess = (state = INITIAL_STATE, { id }) => {
  state = state.set('isPatching', false).set('error', null);
  if (state.getIn(['data', state.get('count'), 'id']) !== id)
    return state;
  return state
    .set('count', state.get('count') + 1)
    .set('details', null);
};

const patchTouchpointError = (state = INITIAL_STATE, { e }) => state
  .set('isPatching', false)
  .set('error', e ? 'Unable to save this touchpoint. Please try again.' : null);

const HANDLERS = {
  [Types.GET_DATA_REQUEST]: getDataRequest,
  [Types.GET_DATA_SUCCESS]: getDataSuccess,
  [Types.GET_DATA_ERROR]: getDataError,
  [Types.GET_DETAILS_REQUEST]: getDetailsRequest,
  [Types.GET_DETAILS_SUCCESS]: getDetailsSuccess,
  [Types.GET_DETAILS_ERROR]: getDetailsError,
  [Types.PATCH_TOUCHPOINT_REQUEST]: patchTouchpointRequest,
  [Types.PATCH_TOUCHPOINT_SUCCESS]: patchTouchpointSuccess,
  [Types.PATCH_TOUCHPOINT_ERROR]: patchTouchpointError
};

export const Actions = {...Types, ...Creators};
export const reducer = createReducer(INITIAL_STATE, HANDLERS);
